import { Component, OnInit, ViewChild } from '@angular/core';
import { LoadingController, AlertController, PopoverController, IonInput, IonicModule } from '@ionic/angular';

import { BeerServiceProvider } from "../../providers/beer-service/beer-service";
import { BrewerySearchRequest, RequestUser, SearchRequest, AddBeerRequest, Brewery, Country, AddBreweryRequest } from "../../models/models";
import { UserDataProvider } from "../../providers/user-data/user-data";

// Formbuilder chosen for unit testing possibility https://ionicframework.com/docs/developer-resources/forms/
import { Validators, FormBuilder, FormGroup, FormControl, ValidatorFn, AbstractControl, ValidationErrors, ReactiveFormsModule } from '@angular/forms';
import { LocationServiceProvider } from '../../providers/location-service/location-service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
// import { BeerDetailPage } from '../beer-detail/beer-detail';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AppEventService } from '../../app/app-events';
// import { NavBarComponent } from '../../components/nav-bar/nav-bar';
import { AddBeerHeaderComponent } from '../../components/add-beer-header/add-beer-header';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AddBeerFormPage_PATH, BeerDetailPage_PATH } from '../../app/app-constants';
import { BhutilProvider } from '../../providers/bhutil/bhutil';


/**
 * Generated class for the AddBeerFormPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-add-beer-form',
  templateUrl: 'add-beer-form.html',
  styleUrls: ['./add-beer-form.scss'],
  standalone: false,
  imports: [
    IonicModule,
//    NavBarComponent,
    AddBeerHeaderComponent,
    ReactiveFormsModule,
    TranslateModule,
    FormsModule,
    CommonModule
  ]
})
export class AddBeerFormPage implements OnInit {
  @ViewChild('breweryname') breweryNameInput: IonInput;

  public static PATH: string = 'addbeer';

  public numberRegex = `[0-9]*`
  breweries: Array<Brewery> = [];
  brewery: Brewery;

  public addBeerForm: FormGroup;
  private inputText: string;
  private searchTerm: string;

  private waitTime: number = 1000; // time (ms) to wait for next keystroke
  private timer: any = 0;

  private noitemstext: String = "";
  private invalidSearch: boolean = false;

  private rowCount: number = 5;
  private pageNumber: number = 1;

  public breweryValue: string;
  public showBreweryList: boolean = false;
  private brewerySelected: boolean = false;
  public isSearching: boolean = false;

  private validBrewery: boolean = false;
  private breweryValueSet: boolean = false;
  private validCountry: boolean = false;
  private countryValueSet: boolean = false;

  loading: any = null;
  private validLeave: boolean = false;

  createBreweryRequested: boolean = false;

  private countries: Array<Country>;
  private countriesToShow: Array<Country>;
  showCountryList: boolean = false;
  private countrySelected: boolean = false;
  countryPagenumber: number = 1;

  brewerynameitemError: string = "";
  countryitemError: string = "";
  cityitemError: string = "";
  beernameitemError: string = "";

  private beerBreweryCombinationError: boolean = false;
  private breweryCityCountryCombinationError: boolean = false;
  private breweryCountryCode: String = null;

  constructor(
    private formBuilder: FormBuilder,
    private beerService: BeerServiceProvider,
    private userData: UserDataProvider,
    private locationService: LocationServiceProvider,
    private events: AppEventService,
    private translateService: TranslateService,
    private router: Router,
    private loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    public popoverCtrl: PopoverController,
    public http: HttpClient,
    private location: Location,
    private bhutil: BhutilProvider
  ) {
    this.addBeerForm = this.formBuilder.group({
      beerName: [bhutil.getStateParam(this.router, 'searchtext'), [Validators.required]],
      breweryId: [null, []], // not required since a new brewery can be made
      breweryName: [null, [Validators.required]],
      breweryCity: [{ value: null, disabled: true }, [Validators.required]],
      breweryCountry: [{ value: null, disabled: true }, [Validators.compose([Validators.required])]],
      abv: [null, [Validators.compose([Validators.min(0), Validators.max(100)])]],
      ibu: [null, [Validators.min(0)]],
      ebc: [null, [Validators.min(0)]],
    });
  }

  searchBreweryChange(event) {
    this.setCreateBreweryRequested(false);
    this.isSearching = false;
    this.breweryValueSet = true;
    if (this.brewerySelected) {
      console.log('add-beer-form - brewery-search-bar - text changed due to brewery selection');
      this.brewerySelected = false;
    } else {
      console.log('add-beer-form - brewery-search-bar - text changed:', event.value);
      this.clearItem("brewerynameitem");
      if (this.breweryCityCountryCombinationError) {
        this.clearItem("countryitem");
        this.clearItem("cityitem");
        this.breweryCityCountryCombinationError = false;
      }
      if (this.beerBreweryCombinationError) {
        this.clearItem("beernameitem");
        this.beerBreweryCombinationError = false;
      }
      this.breweries = [];
      this.showBreweryList = false;
      this.validBrewery = false;
      this.addBeerForm.controls['breweryCountry'].setValue(null);
      this.addBeerForm.controls['breweryCity'].setValue(null);
      this.addBeerForm.controls['breweryId'].setValue(null);
      this.inputText = event.value;
      this.countryValueSet = false;
      this.decideIfToSearch();
    }
  }

  private decideIfToSearch() {
    console.log("add-beer-form - decideIfToSearch")
    // reset
    this.invalidSearch = true;

    // act according to input
    if (this.inputText === "") {
      console.log("add-beer-form - decideIfToSearch - no input");
      this.noitemstext = "";
      return;
    } else if (this.inputText.length < 3) {
      console.log("add-beer-form - decideIfToSearch - enter at least 3 characters before searching...");
      this.noitemstext = this.translateService.instant('ADDBEER.AT_LEAST_3_CHARACTERS_REQUIRED')
      return;
    } else { // valid inputText
      this.noitemstext = "";
      this.searchTerm = this.inputText;
      this.invalidSearch = false;
      this.pageNumber = 1;
      this.timeSearch();
    }
  }

  private timeSearch() {
    this.clearTimer();
    console.log("add-beer-form - brewery-search-bar - timing search");
    this.isSearching = true;
    this.timer = setTimeout(function () {
      console.log("brewery-search-bar - launching search");
      this.executeSearch();
      this.timer = 0;
    }.bind(this), this.waitTime);
    console.log("add-beer-form - brewery-search-bar - timer id = " + this.timer);
  }

  private clearTimer() {
    if (this.timer != 0) {
      // already a timer running, kill it and restart
      clearTimeout(this.timer);
      let oldTimerId: number = this.timer;
      this.timer = 0;
      this.isSearching = false;
      console.log("add-beer-form - brewery-search-bar - cleared timer " + oldTimerId);
    }
  }

  private executeSearch() {
    console.log("add-beer-form - brewery-search-bar - search executing for term: " + this.searchTerm + " asking pageNumber: " + this.pageNumber)
    this.userData.getUserID().then((userID) => {
      console.log("(add-beer-form - user logged in:) " + userID);
      let user = new RequestUser(userID, this.locationService.latitude, this.locationService.longitude);

      let brewerySearchRequest = new BrewerySearchRequest(user.userid, user.latitude, user.longitude, this.searchTerm, "", this.rowCount, this.pageNumber);
      this.beerService.brewerySearch(brewerySearchRequest).subscribe(
        (resp: any) => {
          this.breweries = [];

          if (!this.invalidSearch) {
            let i = 0;
            resp.forEach(element => {
              let brewery = {
                id: element.id,
                country: element.country,
                name: element.name,
                city: element.city
              };
              this.breweries.push(brewery);
            });

            // only show the list if the focus is still on the input field!
            if (document.activeElement.getAttribute("formControlName") == "breweryName") {
              this.showBreweryList = true;
            }
            this.isSearching = false;
          } // if invalidSearch ignore the results
        }, err => console.log(err));
    });
  }

  onAddBeer() {
    if (this.loading == null) {
      this.loading = this.loadingCtrl.create({
        message: this.translateService.instant('GENERAL.PLEASE_WAIT')
      });

      this.loading.present().then(() => {
        setTimeout(() => {
          this.dismissLoading();
        }, 5000);

        this.userData.getUserID().then((userID) => {
          console.log("(add-beer-form - user logged in:) " + userID);
          let user = new RequestUser(userID, this.locationService.latitude, this.locationService.longitude);
          if (this.createBreweryRequested) {
            console.log("add-beer-form - saving beer and creating new brewery");
            this.addBrewery(user);
          } else {
            this.addBeer(user, this.addBeerForm.value.breweryId);
          }
        });
      });
    }
  }

  private addBeer(user, breweryId) {
    console.log("add-beer-form - requesting to add beer to server!")

    let addBeerRequest = new AddBeerRequest(
      user.userid,
      user.latitude,
      user.longitude,
      this.addBeerForm.value.beerName,
      parseFloat(this.addBeerForm.value.abv),
      parseFloat(this.addBeerForm.value.ebc),
      parseFloat(this.addBeerForm.value.ibu),
      breweryId)

    this.beerService.addBeer(addBeerRequest).subscribe(
      (resp: any) => {
        console.log("add-beer-form - saving beer - server responded with id: " + resp.id);

        let beer = {
          beer: {
            id: resp.id,
            logo: '',
            logoUrl: "../assets/svg/icon_beerglass.svg",
            abv: this.addBeerForm.value.abv,
            brewery: {
              id: breweryId,
              country: this.breweryCountryCode,
              name: this.addBeerForm.value.breweryName,
              city: this.addBeerForm.value.breweryCity
            },
            brewery_id: breweryId,
            name: this.addBeerForm.value.beerName
          }
        }

        this.dismissLoading();

        //navigate to the detail screen, with the info preloaded
        this.validLeave = true;
        let leaveWhereToProm = this.alertCtrl.create({
          header: this.translateService.instant('OPENPAGE.BEER_SUCCESSFULLY_ADDED'),
          message: this.translateService.instant('OPENPAGE.THANK_YOU_FOR_CONTRIBUTING_TO_THE_BEERHIVE_COMMUNITY'),
          buttons: [
            {
              text: this.translateService.instant('OPENPAGE.ANALYSE_THIS_BEER'),
              handler: () => {
                console.log('analyse this beer');
                this.router.navigate([ BeerDetailPage_PATH ], { state: { data: {
                  'beer': beer,
                  'sourcetype': 'add-beer-form'
                }}}).then(() => {
                  this.location.back();
                });
              }
            },
            {
              text: this.translateService.instant('OPENPAGE.ADD_ANOTHER_BEER'),
              handler: () => {
                console.log('add another beer');
                this.router.navigate([ AddBeerFormPage_PATH ], { state: { data: {
                  'beer': beer,
                  'sourcetype': 'add-beer-form'
                }}}).then(() => {
                  this.location.back();
                });
              }
            }
          ]
        });
        leaveWhereToProm.then((leaveWhereTo) => leaveWhereTo.present());
      }, err => {
        console.log("add-beer-form - server returned", err.errorCode, "error with message:", err.errorText);
        this.dismissLoading();
        switch (err.errorCode) {
          case "BHFUNCERROR_DUPLICATE_ENTRY":
            let message = this.translateService.instant('ERROR.ADDBEER_BHFUNCERROR_DUPLICATE_ENTRY');
            this.setInvalidItem("brewerynameitem", message);
            this.setInvalidItem("beernameitem", message);
            this.beerBreweryCombinationError = true;
            break;
          default:
            // also contains "BHFUNCERROR_TECHNICAL_ERROR" || "BHFUNCERROR_FUNCTIONAL_ERROR"
            let confirmProm = this.alertCtrl.create({
              header: this.translateService.instant('ERROR.ERROR'),
              message: this.translateService.instant('ERROR.DEFAULT'),
              buttons: [
                {
                  text: this.translateService.instant('GENERAL.OK'),
                  handler: () => {
                    console.log('add-beer-form - error notice - ok clicked');
                  }
                }
              ]
            });
            confirmProm.then((confirm) => confirm.present());
            break;
        }
      }
    );
  }

  private addBrewery(user) {
    console.log("add-beer-form - requesting to add brewery to server!")

    let name = this.addBeerForm.value.breweryName;
    let country = this.breweryCountryCode;
    let city = this.addBeerForm.value.breweryCity;

    let addBreweryRequest = new AddBreweryRequest(
      name,
      country,
      city,
      user.userid,
      user.latitude,
      user.longitude)

    this.beerService.addBrewery(addBreweryRequest).subscribe(
      (resp: any) => {
        console.log("add-beer-form - added brewery - server responded 200!");
        this.addBeer(user, resp.id);
      }, err => {
        console.log("add-brewery-form - server returned", err.errorCode, "error with message:", err.errorText);
        this.dismissLoading();
        switch (err.errorCode) {
          case "BHFUNCERROR_DUPLICATE_ENTRY":
            let message = this.translateService.instant('ERROR.ADDBREWERY_BHFUNCERROR_DUPLICATE_ENTRY');
            this.validBrewery = false;
            this.validCountry = false;
            this.setInvalidItem("countryitem", message);
            this.setInvalidItem("brewerynameitem", message);
            this.setInvalidItem("cityitem", message);
            this.breweryCityCountryCombinationError = true;
            break;
          default:
            // also contains "BHFUNCERROR_TECHNICAL_ERROR" || "BHFUNCERROR_FUNCTIONAL_ERROR"
            let confirmProm = this.alertCtrl.create({
              header: this.translateService.instant('ERROR.ERROR'),
              message: this.translateService.instant('ERROR.DEFAULT'),
              buttons: [
                {
                  text: this.translateService.instant('GENERAL.OK'),
                  handler: () => {
                    console.log('add-brewery-form - error notice - ok clicked');
                  }
                }
              ]
            });
            confirmProm.then((confirm) => confirm.present());
            break;
        }
      });
  }

  ngOnInit() {
    console.log('add-beer-form - ngOnInit');

    // Load countries
    console.log('add-beer-form - retrieving countries')
    this.http.get("assets/countries/countries.json").subscribe(
      res => {
        next: (response: HttpResponse<Object>) => {
          let codes = JSON.parse(response.body.toString());
          this.countries = [];
          for (let i = 0; i < codes.length; i++) {
            let code = codes[i].code;
            this.countries.push({
              code: code,
              name: this.translateService.instant('COUNTRIES.' + code)
            })
          }
      }
      }, err => console.log(err));
  }

  dismissLoading() {
    if (this.loading != null) {
      this.loading.dismiss();
      this.loading = null;
    }
  }

  public helpPressed(field: string) {
    console.log("add-beer-form - help pressed on field: " + field);
    // TODO nice messages based on which button was pressed...
    let title = "";
    let text = "";
    let error = false;
    switch (field) {
      case "abv":
        text = this.translateService.instant('HELP.ABV_DESCRIPTION');
        break;
      case "ibu":
        text = this.translateService.instant('HELP.IBU_DESCRIPTION');
        break;
      case "ebc":
        text = this.translateService.instant('HELP.EBC_DESCRIPTION');
        break;
      default:
        console.log("add-beer-form - help pressed on an unknown field value...");
        error = true;
        break;
    }

    if (!error) {
      this.alertCtrl.create({
        header: title,
        subHeader: text,
        buttons: [this.translateService.instant('GENERAL.OK')]
      }).then((alert) => alert.present());
    }
  }

  ionViewCanLeave(): Promise<void> {
    console.log("add-beer-form ionViewCanLeave request");
    return new Promise((resolve, reject) => {
      if (this.validLeave) {
        resolve();
      } else {
        let confirmProm = this.alertCtrl.create({
          header: this.translateService.instant('OPENPAGE.YOU_HAVE_NOT_SAVED_YOUR_BEER_YET'),
          message: this.translateService.instant('OPENPAGE.ARE_YOU_SURE_YOU_WANT_TO_LEAVE'),
          buttons: [
            {
              text: this.translateService.instant('OPENPAGE.NO_NEVERMIND'),
              role: 'cancel',
              handler: () => {
                console.log('No clicked');
                reject();
              }
            },
            {
              text: this.translateService.instant('OPENPAGE.YES_PLEASE'),
              handler: () => {
                console.log('Yes clicked');
                resolve();
              }
            }
          ]
        });
        confirmProm.then((confirm) => confirm.present());
      }
    })
  }

  ionViewDidEnter() {
    console.log("add-beer-form - ionViewDidEnter")
    this.validLeave = false;
  }


  onBeerNameChange() {
    console.log("add-beer-form - beername changed")
    this.clearItem("beernameitem");
    if (this.beerBreweryCombinationError) {
      this.clearItem("brewerynameitem");
      this.beerBreweryCombinationError = false;
    }
  }

  onBrewerySelect(brewery) {
    console.log("add-beer-form - brewery selected with id: " + brewery.id);
    if (this.breweryNameInput.value != brewery.name) {
      this.brewerySelected = true; // used to avoid onChange detection because of selection, not necessary however when selection is same as input
    }

    this.validBrewery = true;
    this.setValidItem("brewerynameitem");
    this.addBeerForm.get('breweryName').setValue(brewery.name);
    this.addBeerForm.get('breweryCountry').setValue(this.translateService.instant("COUNTRIES." + brewery.country));
    this.addBeerForm.get('breweryCity').setValue(brewery.city);
    this.addBeerForm.get('breweryId').setValue(brewery.id);
    this.breweryCountryCode = brewery.country;
    this.showBreweryList = false;
    this.showCountryList = false;
    this.countrySelected = true;
    this.validCountry = true;
  }

  onNext() {
    console.log("add-beer-form - requested next breweries");
    this.pageNumber++;
    this.executeSearch();
  }

  onPrevious() {
    console.log("add-beer-form - requested previous breweries");
    this.pageNumber--;
    this.executeSearch();
  }

  onCreateBrewery() {
    console.log("add-beer-form - request to create brewery");
    this.showBreweryList = false;
    this.setCreateBreweryRequested(true);
    this.validBrewery = true;
    this.validCountry = false;
    this.setValidItem("breweryname")
  }

  searchCountry(event) {
    console.log("add-beer-form - searching country with value: " + event.value);
    this.countryValueSet = true;
    this.countryPagenumber = 1;
    if (!this.countrySelected) {
      this.clearItem("countryitem");
      if (this.breweryCityCountryCombinationError) {
        this.clearItem("brewerynameitem");
        this.clearItem("cityitem");
        this.breweryCityCountryCombinationError = false;
      }
      this.validCountry = false;
      let searchValue = event.value;

      if (!searchValue) {
        this.countriesToShow = [];
      } else {
        this.countriesToShow = this.countries.filter((v) => {
          if (v.name && searchValue) {
            let translatedName = this.translateService.instant(v.name + "");
            if (translatedName.toLowerCase().indexOf(searchValue.toLowerCase()) > -1) {
              return true;
            }
            return false;
          }
        });
      }

      this.showCountryList = this.countriesToShow.length > 0;
    } else {
      this.countrySelected = false;
    }
  }

  onCountrySelect(country) {
    console.log("add-beer-form - country selected with name: " + country.name + ", " + country.code);
    if (this.breweryCountryCode != country.name) {
      this.countrySelected = true;
    }
    this.validCountry = true;
    this.setValidItem("countryitem");
    this.addBeerForm.get('breweryCountry').setValue(this.translateService.instant(country.name));
    this.breweryCountryCode = country.code;
    this.showCountryList = false;
  }

  onCountryNext() {
    console.log("add-beer-form - next country page");
    this.countryPagenumber++;
  }

  onCountryPrevious() {
    console.log("add-beer-form - previous country page");
    this.countryPagenumber--;
  }

  onOutFocusNumberField(event, formControlName) {
    console.log("add-beer-form - focus changed");
    console.log(event, eval("this.addBeerForm.value." + formControlName))

    let recognizedValue = eval("this.addBeerForm.value." + formControlName);
    if (!recognizedValue) {
      this.addBeerForm.get(formControlName).setValue("null");
      this.addBeerForm.controls[formControlName].reset();//get("abv").setValue("invalid");
    }
  }

  onFocus() {
    console.log("add-beer-form - focussing a new element")
    if (!this.validBrewery && this.breweryValueSet) {
      this.setInvalidItem("brewerynameitem", this.translateService.instant('ADDBEER.PLEASE_SELECT_A_BREWERY_FROM_THE_LIST'));
    }

    if (!this.validCountry && this.countryValueSet) {
      this.setInvalidItem("countryitem", this.translateService.instant('ADDBEER.PLEASE_SELECT_A_COUNTRY_FROM_THE_LIST'));
    }

    this.showCountryList = false;
    this.showBreweryList = false;
  }

  onCityChange() {
    this.clearItem("cityitem");
    if (this.breweryCityCountryCombinationError) {
      this.clearItem("countryitem");
      this.clearItem("brewerynameitem");
      this.breweryCityCountryCombinationError = false;
    }
  }

  setInvalidItem(itemname: string, errormessage: string) {
    console.log("add-beer-form - setting item to invalid: " + itemname + " with message " + errormessage);
    if (eval("this." + itemname + "Error" + " == null")) {
      eval("this." + itemname + "Error" + " = \"" + errormessage + "\"");
    }
    let item = document.getElementById(itemname);
    if (item != null) {
      item.firstElementChild.classList.remove("valid");
      item.firstElementChild.classList.add("invalid");
    }
  }

  setValidItem(itemname: string) {
    console.log("add-beer-form - setting item to valid: " + itemname);
    eval("this." + itemname + "Error" + " = null");
    let item = document.getElementById(itemname);
    if (item != null) {
      item.firstElementChild.classList.remove("invalid");
      item.firstElementChild.classList.add("valid");
    }
  }

  clearItem(itemname: string) {
    console.log("add-beer-form - clearing item: " + itemname);
    eval("this." + itemname + "Error" + " = null");
    let item = document.getElementById(itemname);
    if (item != null) {
      item.firstElementChild.classList.remove("invalid");
      item.firstElementChild.classList.remove("valid");
    }
  }

  setCreateBreweryRequested(value: boolean) {
    console.log("add-beer-form - setting create brewery request to " + value);
    this.createBreweryRequested = value;
    if (value) {
      document.getElementById("countryitem").classList.remove("disabled");
      document.getElementById("cityitem").classList.remove("disabled");
      this.addBeerForm.controls['breweryCity'].enable();
      this.addBeerForm.controls['breweryCountry'].enable();
    } else {
      document.getElementById("countryitem").classList.add("disabled");
      document.getElementById("cityitem").classList.add("disabled");
      this.addBeerForm.controls['breweryCity'].disable();
      this.addBeerForm.controls['breweryCountry'].disable();
    }
  }

  outFocus(event) {
    console.log("out of focus!");
  }

  getCountrySlice() {
    return this.countriesToShow.slice((this.countryPagenumber - 1) * (this.rowCount + 1), this.countryPagenumber * (this.rowCount + 1))
  }
}
